module.exports = __webpack_public_path__ + "images/top-sellers-blue-6977d56f.svg";